// api/apiService.ts
import axios from 'axios';

const apiClient = axios.create({
    baseURL: (import.meta as any).env.VITE_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },

});

apiClient.interceptors.request.use(config => {
    if (!config.headers) {
        config.headers = {};
    }
    config.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('user') || '{}').token || ''}`;
    return config;
});


export const get = async (url: string, params?: Record<string, any>) => {
    try {
        const res = await apiClient.get(url, { params });
        return res.data;
    } catch (error) {
        throw error;
    }
};

export async function post<T>(url: string, data: any): Promise<T> {
    const response = await apiClient.post<T>(url, data);
    return response.data;
}
